<template>
   <div style="margin-left: 30px;" v-loading="loading">
       <product-head :params="params"  @changeHead="changeHead"></product-head>
       <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 10px;" >
           <el-button type=primary @click="submit">确定</el-button>
       </div>
    </div>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>
<script>

import LimitConfigure from  "~/views/order/jiaoben/limitConfigure.vue";
import ProductHead from  "~/views/order/partial/product_head.vue";
import RelationDialog from  "~/views/customer/dialog/relationDialog.vue";
import AccountService from "~/services/CustomerAccounts"
import OrderService from "~/services/order";
import Config from "~/config/params";
export default {
    components:{
        LimitConfigure,
        ProductHead,
        RelationDialog
    },
    data() {
        return {
            loading:true,
            showRelation:false,
            showIsAlreadyRelation:false,
            relationAccounts:[],
            form:{
                order_id:'',
                product_id:'',
                limit_configure:{},
                memo:''
            },
            formLabelWidth:'120px',
        };
    },
    props:{
        params:{
            type:Object,
            required:true
        }
    },
    created() {
        this.form = Object.assign(this.form,this.params.config)
        this.form.order_id = this.params.order_id;
        this.form.product_id = this.params.product_id;
        this.form.type = this.params.open_state;
        this.form.end_at = this.params.end_at;
        this.form.start_at = this.params.start_at;
        this.loading = false;
     //   this.getRelationAccounts();
    },
    methods:{
        closeRelationDialog(show){
            this.showRelation = show;
            this.showIsAlreadyRelation = show;
        },
        handleCloseTag(data){
            this.relationAccounts = this.relationAccounts.filter(item=>{
                return item.uid != data.uid;
            })
        },
        /**
         * 关联账号
         * */
        relationAccount(data){
            let uids = [];
            data.forEach(item=>{
                uids.push(item.uid);
            })
            AccountService.batchSetGroup({uids:uids,group_id:this.currentOption}).then(res=>{
                if(res.code==0){
                    this.getCurrentAccounts();
                }
            })
        },
        /**
         * 修改头部信息
         * @param data
         */
        changeHead(data){
            this.form.type = data.type;
            this.form.end_at = data.end_at;
            this.form.start_at = data.start_at;
            this.form.memo = data.memo;
        },
        /**
         * 提交
         */
        submit(){
            OrderService.reviseProduct(this.form).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: res.msg=='success'?Config.REVISE_NOTICE:res.msg,
                        type: 'success'
                    });
                }
                this.is_submit = false;
            });
        },
        /**
         * 移除账号
         * */
        removeAccount(data){
            this.relationAccounts = this.relationAccounts.filter(i=>{
                return i.uid != data.uid;
            })
        },
        handleDialogConfigureShow(){
            this.$emit('handleDialogConfigureShow',this.form);
        },
        handleSubmitLimitConfigure(params){
            console.log(this.form);
            this.form.limit_configure = params;
        },
        getRelationAccounts()
        {
            AccountService.accountFilter({customer_id:this.customerId,group_id:this.currentOption,perPage:10000}).then(res=>{
                if(res.code==0){
                    this.relationAccounts = [];
                    this.relationAccounts = res.data;
                    this.loading = false;
                }
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/otherProductConfigure.vue